import { receiptsApi } from '../api/receiptsApi'

export const sendBulkReceipts = async () => {
  try {
    const response = await receiptsApi.sendBulkReceipts()
    return response.data
  } catch (error) {
    console.error(`Error sending receipt email: `, error)
    throw error
  }
}
